import { render, staticRenderFns } from "./HistoryPage.vue?vue&type=template&id=ddcf563a&scoped=true&"
import script from "./HistoryPage.vue?vue&type=script&lang=js&"
export * from "./HistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPage.vue?vue&type=style&index=0&id=ddcf563a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcf563a",
  null
  
)

export default component.exports